import * as React from 'react';
import { MemberPageWrapper } from './MemberPageWrapper';

type UserPageWrapperProps = {
    children: React.ReactNode
}

export const UserPageWrapper: React.FunctionComponent<UserPageWrapperProps> = (props:UserPageWrapperProps) => 
    <MemberPageWrapper allowUser={true} selectedMenuItemKey={undefined}>
        {props.children}
    </MemberPageWrapper>